export default "../fonts/akzidgrtskpromed-webfont.e61dfe5a2b5389805e72702bdec3b3a6.woff";